module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_5010.344f62d3.png";